import { Calendar, Check, Star } from "lucide-react";

export const STATS = [
  { icon: Calendar, value: "Depuis 2018", label: "entreprise générale de rénovation" },
  { icon: Check, value: "67 chantiers", label: "livrés" },
  { icon: Star, value: "5,0/5", label: "sur Google – plus de 20 avis" },
];

export default function StaticStats({ compact = false }) {
  return (
    <div data-testid="stats-band" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: compact ? '12px' : '24px' }} className="max-sm:!grid-cols-1">
      {STATS.map((s, i) => (
        <div key={s.value} data-testid={`stat-${i}`} className="max-sm:!justify-start max-sm:!pl-4" style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '12px 0', justifyContent: compact ? 'flex-start' : 'center' }}>
          <s.icon size={28} color="#8B0000" strokeWidth={2} />
          <div>
            <span style={{ color: '#fff', fontWeight: 900, fontSize: compact ? '30px' : '36px', fontFamily: "'Cabinet Grotesk', sans-serif", lineHeight: 1, display: 'block' }}>{s.value}</span>
            <span style={{ display: 'block', color: '#cccccc', fontSize: '14px', fontWeight: 500, marginTop: '4px' }}>{s.label}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
